module.exports = __webpack_public_path__ + "assets/img/svg/common/chevron-down-black.svg?v=1754904930859";